var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('div',{staticClass:"stock-card-item stn-sdw",staticStyle:{"height":"445px"}})])}]

export { render, staticRenderFns }